// extracted by mini-css-extract-plugin
export default {"tags":"Tags_tags__x4-IP","tag":"Tags_tag__9q7UQ"};